export const levelToKorean = {
  Owner: '소유자',
  Author: '편집자',
  Developer: '편집자',
  Tester: '테스터'
};

export const AI_USAGE_GUIDE_URL =
  'https://uniquegoodcompany.notion.site/2ca18b2eed60813a9404fcb24073c631';
